module.exports = __webpack_public_path__ + "img/mfw.49c738dd.png";